<template>
  <div class="ota-edit-view">
    <el-form
      :model="formData"
      :rules="rules"
      v-loading="saveLoading"
      ref="editForm"
      label-position="top"
    >
      <div class="pane-title">基本信息</div>
      <el-form-item prop="platformName" label="平台名称">
        <el-input v-model="formData.platformName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="platformCode" label="房源平台编码">
        <el-input v-if="type === 'add'" v-model="formData.platformCode" placeholder="请输入"></el-input>
        <span v-else>{{ formData.platformCode }}</span>
      </el-form-item>
      <div class="line-tips">编码为部标定义的“网约房平台单位代码”，若部标无定义，从R001开始向后计数生成编码</div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="companyCreditCode" label="社会信用代码">
            <el-input v-model="formData.companyCreditCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyRegName" label="单位注册名称">
            <el-input v-model="formData.companyRegName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyRunName" label="单位经营名称">
            <el-input v-model="formData.companyRunName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="companyEngName" label="单位英文名称">
            <el-input v-model="formData.companyEngName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单位英文缩写">
            <el-input v-model="formData.companyEngNameAbbr" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyLiscenceStartDate" label="营业执照起始日期">
            <el-date-picker v-model="formData.companyLiscenceStartDate" value-format="YYYY-MM-DD" type="date" placeholder="请选择" :clearable="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="营业执照截止日期">
            <el-date-picker v-model="formData.companyLiscenceEndDate" value-format="YYYY-MM-DD" type="date" placeholder="请选择" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="注册资金">
            <el-input-number v-model="formData.companyRegCapital" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="companyPhone" label="联系电话">
            <el-input v-model="formData.companyPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="workAreaCode" label="单位办公地址">
        <AreaCascader v-model="formData.workAreaCode" :end-level="2" :clearable="false" />
      </el-form-item>
      <el-form-item prop="workAddrDetail" label="办公详细地址">
        <el-input v-model="formData.workAddrDetail" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item prop="regAreaCode" label="单位注册地址">
        <AreaCascader v-model="formData.regAreaCode" :end-level="2" :clearable="false" />
      </el-form-item>
      <el-form-item prop="regAddrDetail" label="注册详细地址">
        <el-input v-model="formData.regAddrDetail" placeholder="请输入"></el-input>
      </el-form-item>
      
      <div class="pane-title">法人信息</div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="corporationName" label="法人">
            <el-input v-model="formData.corporationName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人外文姓">
            <el-input v-model="formData.corporationLastName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人外文名">
            <el-input v-model="formData.corporationFirstName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="corporationCountry" label="法人国籍">
            <el-select v-model="formData.corporationCountry" placeholder="请选择" :clearable="false">
              <el-option v-for="item in selOptions.countryCode" :key="item.name" :label="item.value" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="corporationPhone" label="法人联系电话">
            <el-input v-model="formData.corporationPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="corporationCertType" label="法人证件种类">
            <el-select class="w-p-100" v-model="formData.corporationCertType" placeholder="请选择" :clearable="false">
              <el-option v-for="item in selOptions.certType" :key="item.name" :label="item.value" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="corporationCertCode" label="法人证件号码">
            <el-input v-model="formData.corporationCertCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="platformContactName" label="联系人">
            <el-input v-model="formData.platformContactName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="platformContactPhone" label="联系人电话">
            <el-input v-model="formData.platformContactPhone" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item prop="platformContactCertCode" label="联系人身份证号码">
            <el-input v-model="formData.platformContactCertCode" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <div class="pane-title">经营信息</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item prop="webUrl" label="网址">
            <el-input v-model="formData.webUrl" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业类别">
            <el-select class="w-p-100" v-model="formData.industryType" placeholder="请选择" :clearable="false">
              <el-option v-for="item in selOptions.industrytype" :key="item.name" :label="item.value" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="经济类型">
            <el-select class="w-p-100" v-model="formData.businessType" placeholder="请选择" :clearable="false">
              <el-option v-for="item in selOptions.businessType" :key="item.name" :label="item.value" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开业日期">
            <el-date-picker v-model="formData.onlineDate" value-format="YYYY-MM-DD" type="date" placeholder="请选择" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="经营范围（主营）">
        <el-input v-model="formData.businessMain" :autosize="{ minRows: 3, maxRows: 3 }" type="textarea" maxlength="200" show-word-limit placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="经营范围（兼营）">
        <el-input v-model="formData.businessOther" :autosize="{ minRows: 3, maxRows: 3 }" type="textarea" maxlength="200" show-word-limit placeholder="请输入"></el-input>
      </el-form-item>
      <div class="bottom-btn">
        <el-button class="submit-btn" @click="handleConfirm">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import FormCheckMixin from "@/components/common/formCheck.js"
import AreaCascader from '@/components/common/areaCascader'

export default {
  mixins: [FormCheckMixin],
  components: { AreaCascader },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    show: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        id: '',
        platformName: '',
        platformCode: '',
        companyCreditCode: '',
        companyRegName: '',
        companyRunName: '',
        companyEngName: '',
        companyEngNameAbbr: '',
        companyLiscenceStartDate: '',
        companyLiscenceEndDate: '',
        companyRegCapital: 0,
        companyPhone: '',
        workProvinceCode: '',
        workCityCode: '',
        workAreaCode: '',
        workAddrDetail: '',
        regProvinceCode: '',
        regCityCode: '',
        regAreaCode: '',
        regAddrDetail: '',
        corporationName: '',
        corporationLastName: '',
        corporationFirstName: '',
        corporationCountry: '',
        corporationPhone: '',
        corporationCertType: '',
        corporationCertCode: '',
        platformContactName: '',
        platformContactPhone: '',
        platformContactCertCode: '',
        webUrl: '',
        industryType: '',
        businessType: '',
        onlineDate: '',
        businessMain: '',
        businessOther: ''
      },
      rules: {
        platformName: [
          { required: true, message: '请填写平台名称', trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: '请填写房源平台编码', trigger: 'blur' },
          { validator: this.checkPlatformCode, trigger: 'blur' }
        ],
        companyCreditCode: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' },
          { validator: this.checkSocialCode, trigger: 'blur' }
        ],
        companyRegName: [
          { required: true, message: '请填写单位注册名称', trigger: 'blur' }
        ],
        companyRunName: [
          { required: true, message: '请填写单位经营名称', trigger: 'blur' }
        ],
        companyEngName: [
          { required: true, message: '请填写单位英文名称', trigger: 'blur' }
        ],
        companyLiscenceStartDate: [
          { required: true, message: '请选择营业执照起始日期', trigger: 'change' }
        ],
        companyPhone: [
          { required: true, message: '请填写联系电话', trigger: 'blur' },
          { validator: this.checkTel, trigger: 'blur' }
        ],
        workAreaCode: [
          { required: true, message: '请选择单位办公地址', trigger: 'change' }
        ],
        workAddrDetail: [
          { required: true, message: '请填写办公详细地址', trigger: 'blur' }
        ],
        regAreaCode: [
          { required: true, message: '请选择单位注册地址', trigger: 'change' }
        ],
        regAddrDetail: [
          { required: true, message: '请填写注册详细地址', trigger: 'blur' }
        ],
        corporationName: [
          { required: true, message: '请填写法人姓名', trigger: 'blur' }
        ],
        corporationCountry: [
          { required: true, message: '请选择法人国籍', trigger: 'change' }
        ],
        corporationPhone: [
          { required: true, message: '请填写法人联系电话', trigger: 'blur' },
          { validator: this.checkTel, trigger: 'blur' }
        ],
        corporationCertType: [
          { required: true, message: '请选择法人证件种类', trigger: 'change' }
        ],
        corporationCertCode: [
          { required: true, message: '请填写法人证件号码', trigger: 'blur' },
          { validator: this.checkCorporationCertCode, trigger: 'blur' }
        ],
        platformContactName: [
          { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        platformContactPhone: [
          { required: true, message: '请填写联系人电话', trigger: 'blur' },
          { validator: this.checkTel, trigger: 'blur' }
        ],
        platformContactCertCode: [
          { required: true, message: '请填写联系人身份证号码', trigger: 'blur' },
          { validator: this.checkIDCardCode, trigger: 'blur' }
        ],
        webUrl: [
          { validator: this.validateWebsite, trigger: 'blur' }
        ],
      },
      selOptions: {
        certType: [],
        countryCode: [],
        businessType: [],
        industrytype: [],
      },
      selOptionMaps: {
        certType: [],
        countryCode: [],
        businessType: [],
        industrytype: []
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.detail.id) {
            for (let key in this.formData) {
              this.formData[key] = this.detail[key]
            }
            this.formData.companyRegCapital = Number(this.formData.companyRegCapital)
            this.formData.companyRegCapital = isNaN(this.formData.companyRegCapital) ? 0 : this.formData.companyRegCapital

            this.formData.regAreaCode = [this.detail.regProvinceCode, this.detail.regCityCode, this.detail.regAreaCode]
            if (this.formData.regAreaCode[2].length === 6) {
              this.formData.regAreaCode[2] = this.formData.regAreaCode[2] + '000000'
            }
            this.formData.workAreaCode = [this.detail.workProvinceCode, this.detail.workCityCode, this.detail.workAreaCode]
            if (this.formData.workAreaCode[2].length === 6) {
              this.formData.workAreaCode[2] = this.formData.workAreaCode[2] + '000000'
            }

            this.rules.platformCode = []
          } else {
            for (let key in this.formData) {
              this.formData[key] = ''
            }
            this.formData.companyRegCapital = 0

            this.rules.platformCode = [
              { required: true, message: '请填写房源平台编码', trigger: 'blur' },
              { validator: this.checkPlatformCode, trigger: 'blur' }
            ]
          }

          console.log(this.formData);
          this.$refs?.editForm?.clearValidate()
        } else {
          this.$refs?.editForm?.resetFields()
        }
      }
    }
  },
  created() {
    this.getDictData(['certType', 'countryCode', 'businessType', 'industrytype'])
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    // 确认
    handleConfirm() {
      this.$refs.editForm.validate(pass => {
        if (pass) {
          this.saveOrUpdate(this.formData)
        } else {
          this.$message.error('请按要求填写信息！')
        }
      })
    },
    // 取消
    handleCancel() {
      this.$emit('close')
    },
    // 提交保存/更新
    saveOrUpdate(params) {
      let msg = this.type === 'add' ? '新增' : '编辑'

      let url = 'OTA.POST_ADD_OR_UPDATE'
      params = JSON.parse(JSON.stringify(params))
      if (!params.id) delete params.id
      params.regProvinceCode = params.regAreaCode[0]
      params.regCityCode = params.regAreaCode[1]
      params.regAreaCode = params.regAreaCode[2]
      params.workProvinceCode = params.workAreaCode[0]
      params.workCityCode = params.workAreaCode[1]
      params.workAreaCode = params.workAreaCode[2]

      this.fetchData({url, params, method: 'post', flag: true, headers: { "Content-Type": "application/json" }}).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg || msg + '成功')
          this.$emit('success')
        } else {
          this.$message.error(res.msg || msg + '失败')
        }
      })
    },
    // 获取字典数据
    getDictData(types) {
      if (!types || !types.length) return

      let url = 'RESOURCE.GET_MULTI_LIST'
      let params = types.map(item => `types=${item}`).join('&')

      this.fetchData({ url, method: "get", params, isGetParamsDirect: true }).then((res) => {
        if (!res) {
          return console.log(types, '==== 字典获取失败');
        }
        for (let key in res) {
          this.selOptions[key] = res[key]
          this.selOptionMaps[key] = {}
          res[key].forEach(item => {
            this.selOptionMaps[key][item.name] = item.value
          })
        }
      })
    },
    // 校验平台编码
    checkPlatformCode(rule, value, callback) {
      if (value) {
        let list = value.split('')
        if (list.length !== 4) return callback(new Error('房源平台编码为4位数！'))
        if (list[0] !== 'R') return callback(new Error('房源平台编码为 R 开头！'))
        for (let i = 1; i < list.length; i++) {
          if (isNaN(Number(list[i]))) return callback(new Error('房源平台编码后3位为数字！'))
        }

        callback()
      } else {
        callback()
      }
    },
    // 校验法人证件号码
    checkCorporationCertCode(rule, value, callback) {
      if (value && (this.formData.corporationCertType == '111' || this.formData.corporationCertType == '112')) {
        if (!this.checkCNID(value)) {
          return callback(new Error('请输入正确的身份证号！'))
        }
        callback()
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ota-edit-view {
  :deep(.el-cascader), :deep(.el-date-editor), :deep(.el-input-number) {
    width: 100%;
  }
}
.pane-title {
  margin-top: 10px;
  margin-bottom: 18px;
  font-size: 18px;
}
.line-tips {
  margin-top: -3px;
  margin-bottom: 5px;
  font-size: 12px;
  color: rgba(207, 105, 0, 1);
}
.bottom-btn {
  padding-top: 10px;
  text-align: center;
  width: 100%;
}
</style>